import { CopyOutlined, FileTextOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Popover, Row, Tag } from 'antd'
import React from 'react'
import { StatusTag } from './RequestStatusTag'
import { formatters } from '../../../../utils/intl/dateTimeFormatters'
import { PayrollLinkPopover } from '../../Common/PayrollLinkPopover'
const NoteRenderer = ({ notes }) => {
  return (
    <Vertical style={{ gap: '12px' }}>
      {notes?.map((note, i) => (
        <Horizontal
          key={i}
          style={{
            borderRadius: '8px',
            gap: '8px',
          }}
          className='p-1'
        >
          <Vertical>
            <Texto>
              {note.action === 'rejected' && <span style={{ color: 'red' }}>(Rejected) </span>}
              {note.note}
            </Texto>
            <>
              <Texto category='p1' appearance='primary'>
                - {note.username}
              </Texto>
            </>
          </Vertical>
          <Texto category='label' appearance='medium' style={{ textAlign: 'right', flexShrink: 0 }}>
            {formatters.SHORT_DATE_TIME(note.date)}
          </Texto>
        </Horizontal>
      ))}
    </Vertical>
  )
}

export function RequestPayName({ data }) {
  return (
    <Horizontal style={{ height: '100%' }} verticalCenter>
      <Texto className='mr-1'>{data.pay_name}</Texto>
      {data.notes?.length > 0 && (
        <Popover title={<Texto>Special Pay Notes</Texto>} content={() => <NoteRenderer notes={data.notes} />}>
          <GraviButton
            style={{ color: 'var(--theme-color-2)', height: 24, width: 24 }}
            icon={<FileTextOutlined size={16} className='mb-1' />}
            appearance='text'
          />
        </Popover>
      )}
      <PayrollLinkPopover linkedInfo={data.linked_fli_info} timezone={data.timezone_data?.depot} type='accessorial' />
    </Horizontal>
  )
}
